export const scrollToElement = (elementId: string, offset = 0) => {
  const element = document.getElementById(elementId);
  if (element) {
    const scrollElement = element.offsetTop;
    window.scrollTo({ top: scrollElement - offset, behavior: "smooth" });
  }
};
